import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkGfm from 'remark-gfm';
import remarkRehype from 'remark-rehype';
import rehypeStringify from 'rehype-stringify';
import { detectFormat } from './format-detector';
import { log } from './logger';
import type { DetectedFormat } from '../types';

const markdownProcessor = unified()
  .use(remarkParse)
  .use(remarkGfm)
  .use(remarkRehype, { allowDangerousHtml: true })
  .use(rehypeStringify, { allowDangerousHtml: true });

export interface ParseResult {
  html: string;
  format: DetectedFormat;
}

export async function parseSource(source: string): Promise<ParseResult> {
  const format = detectFormat(source);
  log.info('Parsing source', { format, length: source.length });

  if (format === 'html') {
    return { html: source, format };
  }

  const result = await markdownProcessor.process(source);
  return { html: String(result), format };
}
